export const createCheckoutSlice = (set, get) => ({
    componentState: {
        loading: false,
        isEditPlanSelect: true,
        isEditShippingAddress: false,
        isEditShippingMethod: false,
        isEditPaymentMethod: false,
        openValidateAddressDrawer: false,
        validateAddressDrawerState: {
            invalid: false,
            changed: false,
        },
        isUpdatingCart: false,
        checkoutSegment: "",
        openHasAccountDrawer: false,
    },
    shipping_address: {
        firstName: "",
        lastName: "",
        address: "",
        address2: "",
        city: "",
        state: "",
        zip: "",
        country: "US",
    },
    cautiousAddress: {
        firstName: "",
        lastName: "",
        address: "",
        address2: "",
        city: "",
        state: "",
        zip: "",
        country: "",
    },
    billing_address: {
        firstName: "",
        lastName: "",
        address: "",
        address2: "",
        city: "",
        state: "",
        zip: "",
        country: "US",
    },
    shipping_speed: "standard",
    email: "",
    promoError: "",
    paypalNonce: "",
    cardData: {
        brand: "",
        isPaypal: false,
    },
    shippingMethods: {
        shipping_methods: [],
        expedited_shipping_price: 0,
        standard_shipping_price: 0,
    },
    order: [],
    setComponentState: (value) => {
        set({
            componentState: value,
        });
    },
    toggleLoading(value) {
        set({
            componentState: {
                ...get().componentState,
                loading: value !== undefined ? value : !get().componentState.loading,
            },
        });
    },
    setComponentStateField(field, value) {
        set({
            componentState: {
                ...get().componentState,
                [field]: value,
            },
        });
    },
    setShippingAddressField(field, value) {
        set({
            shipping_address: {
                ...get().shipping_address,
                [field]: value,
            },
        });
    },
    setShippingSpeed(value) {
        set({
            shipping_speed: value,
        });
    },
    setShippingAddress(value) {
        set({
            shipping_address: value,
        });
    },
    setEmail(value) {
        set({
            email: value,
        });
    },
    setCautiousAddress(value) {
        set({
            cautiousAddress: value,
        });
    },
    setPromoError(value) {
        set({
            promoError: value,
        });
    },
    setPaypalNonce(value) {
        set({
            paypalNonce: value,
        });
    },
    setCardData(value) {
        set({
            cardData: value,
        });
    },
    setShippingMethods(value) {
        set({
            shippingMethods: value,
        });
    },
    setBillingAddressField(field, value) {
        set({
            billing_address: {
                ...get().billing_address,
                [field]: value,
            },
        });
    },
    setBillingAddress(value) {
        set({
            billing_address: value,
        });
    },
    setOrder(value) {
        set({
            order: value,
        });
    },
    clearCheckoutInfo() {
        set({
            email: undefined,
            shipping_address: undefined,
            cautiousAddress: undefined,
            billing_address: undefined,
        });
    },
});
